import type { TranslationMessages } from '../types';

export const bonuses: TranslationMessages = {
  title: 'Bonuses',
  create: 'Create Bonus',
  edit: 'Edit Bonus',
  name: 'Name',
  name_placeholder: 'e.g., Weekend Bonus',
  description: 'Description',
  description_placeholder: 'Optional description',
  entity_type: 'Entity Type',
  'entity_type.shift': 'Shift',
  'entity_type.attendance': 'Attendance',
  'entity_type.performance': 'Performance',
  'entity_type.other': 'Other',
  position: 'Position',
  all_positions: 'All Positions',
  'position.barista': 'Barista',
  'position.cashier': 'Cashier',
  'position.manager': 'Manager',
  'position.cook': 'Cook',
  'position.server': 'Server',
  staffing_type: 'Staffing Type',
  all_staffing_types: 'All Staffing Types',
  time_of_day: 'Time of Day',
  'time_of_day.morning': 'Morning',
  'time_of_day.afternoon': 'Afternoon',
  'time_of_day.evening': 'Evening',
  'time_of_day.night': 'Night',
  'time_of_day.custom': 'Custom Time Range',
  any_time: 'Any Time',
  custom_time_range: 'Custom Time Range',
  start_time: 'Start Time',
  end_time: 'End Time',
  days_of_week: 'Days of Week',
  'day.sunday': 'Sunday',
  'day.monday': 'Monday',
  'day.tuesday': 'Tuesday',
  'day.wednesday': 'Wednesday',
  'day.thursday': 'Thursday',
  'day.friday': 'Friday',
  'day.saturday': 'Saturday',
  bonus_amount: 'Bonus Amount',
  currency: 'Currency',
  is_active: 'Active',
  conditions: 'Conditions',
  all_conditions: 'All Conditions',
  status: 'Status',
  active: 'Active',
  inactive: 'Inactive',
  actions: 'Actions',
  search: 'Search bonuses...',
  no_bonuses: 'No bonuses found.',
  cancel: 'Cancel',
  save: 'Save',
  saving: 'Saving...',
  delete: 'Delete',
  delete_title: 'Delete Bonus',
  delete_confirm:
    'Are you sure you want to delete this bonus? This action cannot be undone.',
  create_success: 'Bonus created successfully',
  create_error: 'Failed to create bonus',
  update_success: 'Bonus updated successfully',
  update_error: 'Failed to update bonus',
  delete_success: 'Bonus deleted successfully',
  delete_error: 'Failed to delete bonus',
  load_error: 'Failed to load bonuses',
  validation_error: 'Please fill in all required fields',
  user_required: 'User information is required',
  };
